var map = {
	"./replacing-outdated-grievance-processes.mdx": 990,
	"./role-of-technology.mdx": 886,
	"./safer-workplace-culture.mdx": 26,
	"./staff-handbook-is-missing.mdx": 8,
	"./technology-in-workplace-compliance.mdx": 584,
	"blogs/replacing-outdated-grievance-processes.mdx": 990,
	"blogs/role-of-technology.mdx": 886,
	"blogs/safer-workplace-culture.mdx": 26,
	"blogs/staff-handbook-is-missing.mdx": 8,
	"blogs/technology-in-workplace-compliance.mdx": 584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 739;